import moment from "moment";
export function formatDate(inputDateStr) {
  const inputDate = new Date(inputDateStr);

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = dayNames[inputDate.getUTCDay()];
  const month = monthNames[inputDate.getUTCMonth()];
  const date = inputDate.getUTCDate();
  const year = inputDate.getUTCFullYear();
  const time = "00:00:00";
  const timezoneOffset = inputDate.getTimezoneOffset();
  const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60));
  const timezoneOffsetMinutes = Math.abs(timezoneOffset % 60);
  const timezoneOffsetSign = timezoneOffset >= 0 ? "+" : "-";
  const timezoneOffsetStr =
    timezoneOffsetSign +
    padZero(timezoneOffsetHours) +
    padZero(timezoneOffsetMinutes);

  function padZero(number) {
    return number.toString().padStart(2, "0");
  }

  const formattedDate = `${day}%20${month}%20${padZero(
    date
  )}%20${year}%20${time}%20GMT+0530`;

  return formattedDate;
}

export function getFormattedStartDate() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function getFormattedEndDate(daysAgo) {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - daysAgo);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function getFormattedMinusDate(inputDateStr) {
  const inputDate = new Date(inputDateStr);

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = dayNames[inputDate.getUTCDay()];
  const month = monthNames[inputDate.getUTCMonth()];
  const date = inputDate.getUTCDate();
  const year = inputDate.getUTCFullYear();
  const time = "23:59:59";
  const timezoneOffset = inputDate.getTimezoneOffset();
  const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60));
  const timezoneOffsetMinutes = Math.abs(timezoneOffset % 60);
  const timezoneOffsetSign = timezoneOffset >= 0 ? "+" : "-";
  const timezoneOffsetStr =
    timezoneOffsetSign +
    padZero(timezoneOffsetHours) +
    padZero(timezoneOffsetMinutes);

  function padZero(number) {
    return number.toString().padStart(2, "0");
  }

  const formattedDate = `${day}%20${month}%20${padZero(
    date
  )}%20${year}%20${time}%20GMT+0530`;

  return formattedDate;
}

export function generateDateOneString(newDate) {
  const currentDate = new Date(newDate);

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dayOfWeek = daysOfWeek[currentDate.getDay()];
  const month = months[currentDate.getMonth()];
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  const timezoneOffset = currentDate.getTimezoneOffset();
  const timezoneOffsetHours = Math.floor(Math.abs(timezoneOffset) / 60)
    .toString()
    .padStart(2, "0");
  const timezoneOffsetMinutes = (Math.abs(timezoneOffset) % 60)
    .toString()
    .padStart(2, "0");
  const timezoneOffsetSign = timezoneOffset > 0 ? "-" : "+";

  const encodedColon = encodeURIComponent(":").toUpperCase();
  const encodedPlusSign = encodeURIComponent("+").toUpperCase();

  const formattedDate = `${dayOfWeek}+${month}+${day}+${year}`;
  const formattedTime = `${hours}${encodedColon}${minutes}${encodedColon}${seconds}`;
  const formattedTimezoneOffset = `GMT${timezoneOffsetSign}${timezoneOffsetHours}${timezoneOffsetMinutes}`;

  const finalString = `${formattedDate}+${formattedTime}+${formattedTimezoneOffset}`;

  return finalString;
}

export function summaryEndDate(date) {
  const formattedDate = moment(date).format("ddd%20MMM%20DD%20YYYY%20HH:mm:ss");
  const timeZoneOffset = moment().format("Z").replace(":", "");
  const currentTime = moment().format("HH:mm:ss");
  return `${formattedDate.replace(
    "00:00:00",
    currentTime
  )}%20GMT${timeZoneOffset}`;
}

export function summaryStartOne(date) {
  const formattedDate = moment(date).format("ddd MMM DD YYYY HH:mm:ss");
  const timeZoneOffset = moment().format("Z").replace(":", "");
  const encodedDate = encodeURIComponent(formattedDate);
  const encodedTimeZoneOffset = encodeURIComponent(`GMT${timeZoneOffset}`);
  return `${encodedDate.replace(/%20/g, "+")}+${encodedTimeZoneOffset}`;
}

export function summaryEndOne(date) {
  const formattedDate = moment(date).format("ddd+MMM+DD+YYYY+HH:mm:ss");
  const timeZoneOffset = moment().format("Z").replace(":", "");
  const encodedDate = encodeURIComponent(formattedDate).replace(/%20/g, "+");
  const encodedTimeZoneOffset = encodeURIComponent(
    `GMT${timeZoneOffset}`
  ).replace(/%2B/g, "+");
  return `${encodedDate}+${encodedTimeZoneOffset}`;
}

export function revenueRepStartDate(dateString) {
  // const formattedDate = moment
  //   .utc(dateString + "T18:30:00.000Z")
  //   .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  // return formattedDate;
  const momentDate = moment.utc(dateString, "YYYY-MM-DD");
  const formattedISOString = momentDate.format("YYYY-MM-DD") + "T18:30:00.000Z";
  return formattedISOString;
}
export function revenueRepEndDate(dateString) {
  const momentDate = moment.utc(dateString, "YYYY-MM-DD");
  const formattedISOString = momentDate.format("YYYY-MM-DD") + "T18:29:59.999Z";
  return formattedISOString;
//   const formattedDate = moment
//   .utc(dateString + "T18:29:59.999Z")
//   .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
// return formattedDate;
}

const groupBy = (array, keyFn) => {
  return array.reduce((groups, item) => {
    const key = keyFn(item);
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
    return groups;
  }, {});
};

const tags = [
  { key: "Prescription Call", value: "Prescription Call" },
  { key: "Week #1", value: "Week 1" },
  { key: "Week #2", value: "Week 2" },
  { key: "Week #3", value: "Week 3" },
  { key: "Week #4", value: "Week 4" },
  { key: "Week #5", value: "Week 5" },
  { key: "Week #6", value: "Week 6" },
  { key: "retention", value: "Retention and others" },
];

const engagementSchedules = (engagement, data) => {
  if (typeof engagement !== "string") return;

  const default_data = {
    name: engagement,
    key: `engagementSchedules_${engagement.replaceAll(" ", "_")}`,
    calls: 0,
    completed: 0,
    finished: 0,
    autoCompleted: 0,
    unfinished: 0,
    attempt_1: 0,
    attempt_2: 0,
    attempt_3: 0,
    attempts: 0,
  };

  if (!Array.isArray(data)) return default_data;
  default_data["calls"] = data.length;

  return data.reduce((acc, curr) => {
    const unansweredCount = Number(curr.unanswered_count);

    if (finishedEngagements.has(curr.operation_status)) {
      const _nextAttempt = nextAttempt(unansweredCount);
      if (typeof acc[_nextAttempt] === "number") {
        acc[_nextAttempt] = acc[_nextAttempt] + 1;
      } else {
        acc[_nextAttempt] = 1;
      }

      // acc["finished"] = acc["finished"] + 1;
      if (curr.operation_status === "auto_completed") {
        acc["autoCompleted"] = acc["autoCompleted"] + 1;
      }
      if (curr.operation_status === "completed") {
        acc["completed"] = acc["completed"] + 1;
      }
    } else {
      const _attempt = attempt(unansweredCount);

      if (typeof acc[_attempt] === "number") acc[_attempt] = acc[_attempt] + 1;
      else acc[_attempt] = 1;

      acc["unfinished"] = acc["unfinished"] + 1;
    }
    if (curr.operation_status === null && Number(curr.unanswered_count) > 0) {
      acc["attempts"] = acc["attempts"] + 1;
    }

    return acc;
  }, default_data);
};

const engagementScheduleRetentionGroup = [
  "Week 2",
  "Week 4",
  "Week 5",
  "Week 6",
  "Retention and others",
];
const finishedEngagements = new Set(["auto_completed", "completed"]);
const attempt = (count) => `attempt_${count}`;
const nextAttempt = (count) => attempt(count + 1);

const reminderSchedules = (tag, data) => {
  const default_data = {
    name: tag,
    key: `engagementSchedules_${tag}`,
    calls: 0,
    finished: 0,
    completed: 0,
    autoCompleted: 0,
    unfinished: 0,
    attempt_1: 0,
    attempt_2: 0,
    attempt_3: 0,
    attempts: 0,
  };

  if (!Array.isArray(data)) return default_data;
  default_data["calls"] = data.length;

  return data.reduce((acc, curr) => {
    const unansweredCount = Number(curr.unanswered_count);

    if (curr.status === "active") {
      const _attempt = attempt(unansweredCount);

      if (typeof acc[_attempt] === "number") acc[_attempt] = acc[_attempt] + 1;
      else acc[_attempt] = 1;

      acc["unfinished"] = acc["unfinished"] + 1;
    } else {
      const _nextAttempt = nextAttempt(unansweredCount);
      if (typeof acc[_nextAttempt] === "number") {
        acc[_nextAttempt] = acc[_nextAttempt] + 1;
      } else {
        acc[_nextAttempt] = 1;
      }

      // acc["finished"] = acc["finished"] + 1;
      acc["completed"] = acc["completed"] + 1;
    }

    return acc;
  }, default_data);
};

export const engagementScheduleFn = ({ engagements, reminders }) => {
  if (!Array.isArray(engagements)) engagements = [];
  if (!Array.isArray(reminders)) reminders = [];

  const _repGroups = groupBy(engagements, (row) => row.rep_id);
  const _groupRemindersByReps = groupBy(reminders, (row) => row.user_id);
  let finalData = [];

  const retentionData = {
    name: "Retention and others",
    key: "engagementSchedulesRetention",
    calls: 0,
    finished: 0,
    unfinished: 0,
  };

  for (const repId in _repGroups) {
    const _groupEngagements = groupBy(
      _repGroups[repId],
      (row) => row.engagement_tag
    );
    const retentionData = {
      name: "Retention and others",
      key: "engagementSchedulesRetention",
      calls: 0,
      finished: 0,
      completed: 0,
      autoCompleted: 0,
      attempts: 0,
      unfinished: 0,
    };
    let _finalData = [];
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i];
      const _data = _groupEngagements[tag.key];
      const _engagementSchedule = engagementSchedules(tag.value, _data);
      if (engagementScheduleRetentionGroup.includes(_engagementSchedule.name)) {
        retentionData.calls += _engagementSchedule.calls;
        retentionData.finished += _engagementSchedule.finished;
        retentionData.completed += _engagementSchedule.completed;
        retentionData.autoCompleted += _engagementSchedule.autoCompleted;
        retentionData.attempts += _engagementSchedule.attempts;
        retentionData.unfinished += _engagementSchedule.unfinished;
      } else {
        _finalData = _finalData.concat(_engagementSchedule);
      }
    }
    _finalData = _finalData.concat(retentionData);
    _finalData = _finalData.concat([
      reminderSchedules(
        "Slot Bookings",
        _groupRemindersByReps[repId] ? _groupRemindersByReps[repId] : []
      ),
    ]);
    const transformData = _finalData.reduce(
      (acc, curr) => {
        acc["Calls"][curr.key] = curr.calls;
        acc["Completed"][curr.key] = curr.completed;
        acc["Auto completed"][curr.key] = curr.autoCompleted;
        acc["Attempts"][curr.key] = curr.attempts;
        acc["Unfinished"][curr.key] = curr.unfinished;
        return acc;
      },
      {
        Calls: {},
        Completed: {},
        "Auto completed": {},
        Attempts: {},
        Unfinished: {},
      }
    );

    const _modifiedFinalData = Object.entries(transformData).map(
      ([key, value]) => {
        return {
          hairCoach: repId,
          type: key,
          prescriptionCall: value["engagementSchedules_Prescription_Call"],
          week1: value["engagementSchedules_Week_1"],
          week3: value["engagementSchedules_Week_3"],
          retentionAndOthers: value["engagementSchedulesRetention"],
          slotBookings: value["engagementSchedules_Slot Bookings"],
          total:
            value["engagementSchedules_Prescription_Call"] +
            value["engagementSchedules_Week_1"] +
            value["engagementSchedules_Week_3"] +
            value["engagementSchedulesRetention"] +
            value["engagementSchedules_Slot Bookings"],
        };
      }
    );
    finalData = finalData.concat(_modifiedFinalData);
  }
  return finalData;
};

  //Get the Latest ticket Details by Category
  export function latestTicketByCategory(ticketArray) {
    return _.maxBy(
      _.filter(ticketArray, ticket => 
        ["medical_escalations", "customer_complaints"].includes(ticket.category)
      ),
      "createdAt"
    );
  }